import { noopAsync } from '@app/utils/noop'

type ShareFunction = (data: { url?: string; text?: string; title?: string }) => Promise<void>

const share = (() => {
  if (!IS_BROWSER) return null
  if (!('share' in window.navigator)) return null
  return (window.navigator as any).share.bind(window.navigator)
})()

export const useShareApi = (): [boolean, ShareFunction] => {
  if (!share) return [false, noopAsync]
  return [true, share]
}
